import React, { useState, useEffect, useRef, useCallback } from "react";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import {
  IIdValuePairResponse,
  INewsfeedListProps,
} from "../../../interfaces/Index";
import { _ } from "../../../utils/lib";
import ButtonComponent from "../../common/Button/ButtonComponent";
import DataTable from "../../common/DataTable/DataTable";
import Toaster from "../../common/Toaster/Toaster";
import LoaderComponent from "../../common/Loader/Loader";
import {
  headerData,
  bodyDataAndKeyTypes,
  footerData,
} from "./NewsfeedTableConstants";
import { Can } from "../../../config/Can";
import "./Newsfeed.scss";
import searchicon from "../../../assets/images/search-icon.svg";
import close from "../../../assets/images/close.svg";
// import SearchableSelect from "../../common/SearchableSelect/SearchableSelect";

export const doAPIsearch = (
  val: any,
  pageScrollPosition: any,
  getNewsfeedList: any,
  cityId: any
) => {
  if (val.length >= 1) {
    pageScrollPosition.current = 0;
    getNewsfeedList({
      searchKey: val,
    });
  }
};

const NewsfeedList: React.FunctionComponent<INewsfeedListProps> = (
  props: INewsfeedListProps
) => {
  let pageScrollPosition: any = useRef(props.currentListPosition);
  const [isSearch, setIsSearching] = useState(
    props.retainedSearchText ? true : false
  );
  const [searchTerm, setSearchTerm] = useState(props.retainedSearchText);
  const [isLoadMore, setLoadMore] = useState(false);
  const [loadMoreText, setLoadMoreText] = useState({
    text: "Load more...",
    isLoading: false,
  });
  const [newsfeedData, setData] = useState<Array<any>>([]);
  const [selectedCity, setSelectedCity] = useState<IIdValuePairResponse>(
    props.selectedCity as any
  );
  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  //NOTE: The below mentioned code is leaved here as it will be required when we convert it newsfeed as city level

  // useEffect(() => {
  //   const { fetchCities } = props;
  //   fetchCities();
  // }, []);

  useEffect(() => {
    // if (!selectedCity) {
    //   const newSelectedCity =
    //     props.citiesList && props.citiesList.length
    //       ? props.citiesList[0]
    //       : selectedCity;
    // }
    handleSelectedCityChange();
  }, [props.citiesList, selectedCity.id]);

  // useEffect(() => {
  //   const { newsfeedListFetched, isNewsfeedAddedorUpdated, getNewsfeedList } = props;

  //   if (newsfeedListFetched.length === 0 || isNewsfeedAddedorUpdated) {
  //     if (selectedCity && selectedCity.id.length) {
  //       getNewsfeedList();
  //     }
  //     window.scrollTo(0, 0);
  //   } else {
  //     window.scrollTo(0, pageScrollPosition.current);
  //   }
  // }, [
  //   props.citiesList.length,
  //   props.isCityListFetched,
  //   selectedCity,
  //   props.currentLocation,
  // ]);

  useEffect(() => {
    const { newsfeedListFetched, pagination } = props;
    if (newsfeedListFetched) {
      setData(newsfeedListFetched);
      setTimeout(() => {
        window.scrollTo(
          0,
          window.pageYOffset - (window.pageYOffset - pageScrollPosition.current)
        );
      }, 250);
      if (pagination) {
        setLoadMore(true);
        setLoadMoreText({
          text: "Load more...",
          isLoading: false,
        });
      } else {
        setLoadMore(false);
      }
    }
  }, [props.newsfeedListFetched]);

  useEffect(() => {
    const { error, isError } = props;
    if (isError && error) {
      alert((error! as any).errors);
    }
  }, [props.isError]);

  useEffect(() => {
    if (props.isNewsfeedAdded || props.isNewsfeedUpdated) {
      const message = props.isNewsfeedAdded
        ? "Newsfeed created successfully!"
        : "Newsfeed status updated successfully";
      handleToaster(false, message);
    } else {
      const { error, isError } = props;
      if (isError && error) {
        handleToaster(true, (error! as any).errors);
      }
    }
  }, [props.isNewsfeedAdded, props.isNewsfeedUpdated]);

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const debounceSearch = useCallback(
    _.debounce(
      (value: any, cityId: any) =>
        doAPIsearch(value, pageScrollPosition, props.getNewsfeedList, cityId),
      1000
    ),
    []
  );

  const handleSearchInputChange = (e: any) => {
    const { getNewsfeedList } = props;
    const value = e.target.value;
    setSearchTerm(value);
    debounceSearch(value, selectedCity.id);

    if (value.length > 0 && !isSearch) {
      setIsSearching(true);
    }
    if (value.length === 0 && isSearch) {
      getNewsfeedList({
        searchKey: value,
      });
    }
  };

  const editNewsfeed = (e: any, i: number) => {
    const { addUpdatePageHandler } = props;

    addUpdatePageHandler(
      selectedCity,
      true,
      newsfeedData[i],
      searchTerm,
      window.pageYOffset
    );
  };

  const closeSearch = () => {
    pageScrollPosition.current = 0;
    const { getNewsfeedList } = props;
    getNewsfeedList();
    setIsSearching(false);
    setSearchTerm("");
  };

  const loadFunc = () => {
    const { getNewsfeedList, pagination } = props;
    if (pagination) {
      pageScrollPosition.current = window.pageYOffset;
      setLoadMoreText({
        text: "Loading...",
        isLoading: true,
      });
      if (isSearch) {
        getNewsfeedList({
          page: pagination,
          searchKey: searchTerm,
        });
      } else {
        getNewsfeedList({
          page: pagination,
        });
      }
    }
  };

  const handleSelectedCityChange = () => {
    const { getNewsfeedList } = props;

    getNewsfeedList();
    setSelectedCity(selectedCity);
  };

  return (
    <div className="newsfeed-list-container">
      {props.isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <section className="relative container sticky-top">
        <section className="row">
          <section className="col-9">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <img src={searchicon} alt="close" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                className="search-input"
                placeholder="Search by post ID"
                onChange={handleSearchInputChange}
                value={searchTerm}
              />
              {/* <div className="input-group-append">
                <SearchableSelect
                  id="title"
                  isSearchable={true}
                  options={props.citiesList}
                  onChange={handleSelectedCityChange}
                  selectedValue={selectedCity}
                />
              </div> */}
              <div
                className={isSearch ? "close-button" : "hide close-button"}
                onClick={closeSearch}
              >
                <img src={close} alt="close" />
              </div>
            </InputGroup>
          </section>
          <section className="col-3">
            <Can I="create" a="post">
              <ButtonComponent
                buttonText="New content"
                onClickHandler={() =>
                  props.addUpdatePageHandler(
                    selectedCity,
                    false,
                    null,
                    searchTerm,
                    window.pageYOffset
                  )
                }
                buttonClass="btn-primary btn btn-secondary button-large"
              />
            </Can>
          </section>
        </section>
      </section>
      <Can I="read" a="post">
        <DataTable
          tableId="newsfeed-list"
          tableHeaderData={headerData}
          tableFooterData={footerData}
          tableBodyDataTypes={bodyDataAndKeyTypes}
          tableBodyRowData={newsfeedData}
          noSearchResultFlag={isSearch}
          editRowHandler={editNewsfeed}
        />
        {isLoadMore && (
          <div id="load-more-container">
            <ButtonComponent
              buttonText={loadMoreText.text}
              buttonClass="btn-primary-outline button-medium"
              onClickHandler={loadFunc}
              isDisable={loadMoreText.isLoading}
            />
          </div>
        )}
      </Can>
    </div>
  );
};

export default NewsfeedList;
